import { memo } from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import CustomAlert from '../../../components/Shared/Alert/CustomAlert';
import {
  DeleteAmeCondition,
  GetAmeCondition,
  cleanAmeConditionList,
} from '../../../store/Ame/ameSlice';
import { usePermissions } from '../../../Helper/Permisstions/usePermissions';
import showConfirmation from '../../../components/Shared/Alert/Confirmation';
import NoData from '../../../components/NoData/NoData';

const ConditionList = ({ id }) => {
  const { HasPermission } = usePermissions();

  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(GetAmeCondition(id));

    return () => {
      dispatch(cleanAmeConditionList());
    };
  }, [dispatch, id]);
  const { AmeConditionList } = useSelector((state) => state.Ame);

  const handleDeleteAmeCondition = (item) => {
    showConfirmation(t('MsgConfirm'), () => {
      dispatch(DeleteAmeCondition(item.id))
        .unwrap()
        .then(() => {
          dispatch(GetAmeCondition(id));
          CustomAlert({ action: 'Delete' });
        })
        .catch((error) => {
          console.log(error);
          CustomAlert({ action: 'Error' });
        });
    });
  };

  return (
    <div className="mt-2">
      {AmeConditionList?.length > 0 ? (
        <div className="table-responsive rounded-2 text-center ">
          <table className="table  table-hover text-nowrap mb-0">
            <thead className="bg-theme bg-opacity-60">
              <tr>
                {/* <th scope="col">الرقم </th> */}
                <th>#</th>
                <th>{t('ConditionDescription')}</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              {AmeConditionList &&
                AmeConditionList?.map((item, idx) => (
                  <tr key={++idx}>
                    <td className="align-middle">{++idx}</td>
                    <td className="align-middle">
                      {i18n.language === 'ar' ? item?.name : item?.name2}
                    </td>
                    <td className="align-middle">
                      {HasPermission('AmeDeleteConditionsOrder') && (
                        <>
                          <button
                            type="button"
                            className="btn btn-outline-danger m-0"
                            onClick={() => handleDeleteAmeCondition(item)}>
                            <i className="fas fa-trash-alt fa-fw fa-lg"></i>
                            {/* {t('Button.Delete')} */}
                          </button>
                        </>
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="table-responsive rounded-2 text-center">
      <table className="table table-hover text-nowrap mb-0">
        <thead className="bg-theme bg-opacity-60">
          <tr>
            <th>#</th>
            <th>{t('ConditionDescription')}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colSpan="3" className="text-center">
              <NoData message="لا يوجد شروط لهذا الطلب" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>

      )}
    </div>
  );
};

export default memo(ConditionList);
